// Import necessary modules
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';

// CSS image replacement
export class TextHide extends Mixin {
  style({$}, [ignoreWarning=false]) {
    // stylelint-disable-next-line font-family-no-missing-generic-family-keyword
    return css`
      font: 0/0 a;
      color: transparent;
      text-shadow: none;
      background-color: transparent;
      border: 0;
    `;
  }
}